export const arcParticipant = {
    type: "none",
    itemId: "contactInformation",
    className: "container",
    items: [
        // Name
        {
            type: "dropdown",
            itemId: "prefix",
            label: "Prefix",
            className: "col-md-3",
            visible: false,
            items: [
                {
                    type: "selection",
                    itemId: "pre_attn",
                    label: "Attn",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_brother",
                    label: "Brother",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_cityof",
                    label: "City of",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_dba",
                    label: "DBA",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_deptof",
                    label: "Dept of",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_dr",
                    label: "Dr",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_estateof",
                    label: "Estate of",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_father",
                    label: "Father",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_l",
                    label: "L",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_la",
                    label: "La",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_le",
                    label: "Le",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_les",
                    label: "Les",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_mile",
                    label: "Mile",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_miss",
                    label: "Miss",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_misses",
                    label: "Misses",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_mm",
                    label: "MM",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_mme",
                    label: "Mme",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_mr",
                    label: "Mr",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_mrs",
                    label: "Mrs",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_ms",
                    label: "Ms",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_professor",
                    label: "Professor",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_reverend",
                    label: "Reverend",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_sister",
                    label: "Sister",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_stateof",
                    label: "State of",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_the",
                    label: "The",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_trustof",
                    label: "Trust of",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "pre_universityof",
                    label: "University of",
                    data: {}
                }
            ]
        },
        {
            type: "text",
            itemId: "firstName",
            label: "First Name",
            className: "col-md-4",
            required: true,
            maxLength: 30,
            rules: {
                firstName: {
                    "firstName.valid": { compare: ["#firstName.value.length", "<", 31] }
                }
            }
        },
        {
            type: "text",
            itemId: "middleName",
            label: "Middle Name",
            className: "col-md-4",
            maxLength: 16,
            rules: {
                middleName: {
                    "middleName.valid": {
                        any: [
                            { compare: ["#middleName.value", "==", ""] },
                            { compare: ["#middleName.value.length", "<", 17] }
                        ]
                    }
                }
            }
        },
        {
            type: "text",
            itemId: "lastName",
            label: "Last Name",
            className: "col-md-4",
            required: true,
            maxLength: 30,
            rules: {
                lastName: {
                    "lastName.valid": { compare: ["#lastName.value.length", "<", 31] }
                }
            }
        },
        {
            type: "dropdown",
            itemId: "suffix",
            label: "Suffix",
            className: "col-md-3",
            visible: false,
            items: [
                {
                    type: "selection",
                    itemId: "suf_aka",
                    label: "AKA",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_apm",
                    label: "APM",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_arm",
                    label: "ARM",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_attorney",
                    label: "Attorney",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_cic",
                    label: "CIC",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_cnm",
                    label: "CNM",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_corp",
                    label: "Corp",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_cpa",
                    label: "CPA",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_cpcu",
                    label: "CPCU",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_crm",
                    label: "CRM",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_crna",
                    label: "CRNA",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_dds",
                    label: "DDS",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_dmd",
                    label: "DMD",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_do",
                    label: "DO",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_dpm",
                    label: "DPM",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_dpt",
                    label: "DPT",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_dvm",
                    label: "DVM",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_esq",
                    label: "Esq",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_ii",
                    label: "II",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_iii",
                    label: "III",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_inc",
                    label: "Inc",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_iv",
                    label: "IV",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_jr",
                    label: "Jr",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_md",
                    label: "MD",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_np",
                    label: "NP",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_od",
                    label: "OD",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_pa",
                    label: "PA",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_pac",
                    label: "PAC",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_phd",
                    label: "PhD",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_pt",
                    label: "PT",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_rn",
                    label: "RN",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_sr",
                    label: "Sr",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_university",
                    label: "University",
                    data: {}
                },
                {
                    type: "selection",
                    itemId: "suf_v",
                    label: "V",
                    data: {}
                }
            ]
        },
        {
            type: "text",
            itemId: "businessName",
            label: "Company Name",
            required: true,
            visible: false
        },
        // Communication
        {
            type: "text",
            itemId: "email",
            label: "Email Address",
            className: "col-md-4",
            required: true,
            rules: {
                email: {"email.valid":
                    { compare: ["#email.value", "regex", "^[\\w\\-\\.]+@([\\w-]+\\.)+[\\w-]{2,}$"] }
                }
            }
        },
        {
            type: "text",
            itemId: "phone",
            label: "Phone Number",
            className: "col-md-4",
            mask: "(000) 000-0000",
            required: true,
            rules: {
                phone: {
                     "phone.valid": { all: [
                        { compare: ["#phone.value.1", ">", 1] }, // (100) 000-0000
                        { compare: ["#phone.value.6", ">", 1] }, // (000) 100-0000
                        { compare: ["#phone.value.length", "==", 14] }]
                     }
                    }
            }
        },
        {
            type: "text",
            itemId: "fax",
            label: "Fax",
            className: "col-md-4",
            mask: "(000) 000-0000"
        },
        // Location
        {
            type: "text",
            itemId: "addressLine1",
            label: "Address",
            className: "col-md-6",
            required: true
        },
        {
            type: "text",
            itemId: "addressLine2",
            label: "Address 2",
            className: "col-md-6"
        },
        {
            type: "text",
            itemId: "city",
            label: "City",
            className: "col-md-4",
            required: true
        },
        {
            type: "dropdown",
            itemId: "state",
            label: "State",
            className: "col-md-4",
            required: true,
            items: [
                {
                    type: "selection",
                    itemId: "alabama",
                    label: "Alabama",
                    data: { stateId: 1, stateCode: "AL", stateName: "Alabama" }
                },
                {
                    type: "selection",
                    itemId: "alaska",
                    label: "Alaska",
                    data: { stateId: 2, stateCode: "AK", stateName: "Alaska" }
                },
                {
                    type: "selection",
                    itemId: "arizona",
                    label: "Arizona",
                    data: { stateId: 4, stateCode: "AZ", stateName: "Arizona" }
                },
                {
                    type: "selection",
                    itemId: "arkansas",
                    label: "Arkansas",
                    data: { stateId: 5, stateCode: "AR", stateName: "Arkansas" }
                },
                {
                    type: "selection",
                    itemId: "california",
                    label: "California",
                    data: { stateId: 6, stateCode: "CA", stateName: "California" }
                },
                {
                    type: "selection",
                    itemId: "colorado",
                    label: "Colorado",
                    data: { stateId: 7, stateCode: "CO", stateName: "Colorado" }
                },
                {
                    type: "selection",
                    itemId: "connecticut",
                    label: "Connecticut",
                    data: { stateId: 8, stateCode: "CT", stateName: "Connecticut" }
                },
                {
                    type: "selection",
                    itemId: "delaware",
                    label: "Delaware",
                    data: { stateId: 9, stateCode: "DE", stateName: "Delaware" }
                },
                {
                    type: "selection",
                    itemId: "distOfColumbia",
                    label: "Dist. of Columbia",
                    data: { stateId: 10, stateCode: "DC", stateName: "Dist. of Columbia" }
                },
                {
                    type: "selection",
                    itemId: "florida",
                    label: "Florida",
                    data: { stateId: 11, stateCode: "FL", stateName: "Florida" }
                },
                {
                    type: "selection",
                    itemId: "georgia",
                    label: "Georgia",
                    data: { stateId: 12, stateCode: "GA", stateName: "Georgia" }
                },
                {
                    type: "selection",
                    itemId: "hawaii",
                    label: "Hawaii",
                    data: { stateId: 14, stateCode: "ID", stateName: "Hawaii" }
                },
                {
                    type: "selection",
                    itemId: "idaho",
                    label: "Idaho",
                    data: { stateId: 15, stateCode: "ID", stateName: "Idaho" }
                },
                {
                    type: "selection",
                    itemId: "illinois",
                    label: "Illinois",
                    data: { stateId: 16, stateCode: "IL", stateName: "Illinois" }
                },
                {
                    type: "selection",
                    itemId: "indiana",
                    label: "Indiana",
                    data: { stateId: 17, stateCode: "IN", stateName: "Indiana" }
                },
                {
                    type: "selection",
                    itemId: "iowa",
                    label: "Iowa",
                    data: { stateId: 18, stateCode: "IA", stateName: "Iowa" }
                },
                {
                    type: "selection",
                    itemId: "kansas",
                    label: "Kansas",
                    data: { stateId: 19, stateCode: "KS", stateName: "Kansas" }
                },
                {
                    type: "selection",
                    itemId: "kentucky",
                    label: "Kentucky",
                    data: { stateId: 20, stateCode: "KY", stateName: "Kentucky" }
                },
                {
                    type: "selection",
                    itemId: "louisiana",
                    label: "Louisiana",
                    data: { stateId: 21, stateCode: "LA", stateName: "Louisiana" }
                },
                {
                    type: "selection",
                    itemId: "maine",
                    label: "Maine",
                    data: { stateId: 22, stateCode: "ME", stateName: "Maine" }
                },
                {
                    type: "selection",
                    itemId: "maryland",
                    label: "Maryland",
                    data: { stateId: 23, stateCode: "MD", stateName: "Maryland" }
                },
                {
                    type: "selection",
                    itemId: "massachusetts",
                    label: "Massachusetts",
                    data: { stateId: 25, stateCode: "MA", stateName: "Massachusetts" }
                },
                {
                    type: "selection",
                    itemId: "michigan",
                    label: "Michigan",
                    data: { stateId: 26, stateCode: "MI", stateName: "Michigan" }
                },
                {
                    type: "selection",
                    itemId: "minnesota",
                    label: "Minnesota",
                    data: { stateId: 28, stateCode: "MN", stateName: "Minnesota" }
                },
                {
                    type: "selection",
                    itemId: "mississippi",
                    label: "Mississippi",
                    data: { stateId: 29, stateCode: "MS", stateName: "Mississippi" }
                },
                {
                    type: "selection",
                    itemId: "missouri",
                    label: "Missouri",
                    data: { stateId: 30, stateCode: "MO", stateName: "Missouri" }
                },
                {
                    type: "selection",
                    itemId: "montana",
                    label: "Montana",
                    data: { stateId: 31, stateCode: "MT", stateName: "Montana" }
                },
                {
                    type: "selection",
                    itemId: "nebraska",
                    label: "Nebraska",
                    data: { stateId: 32, stateCode: "NE", stateName: "Nebraska" }
                },
                {
                    type: "selection",
                    itemId: "nevada",
                    label: "Nevada",
                    data: { stateId: 33, stateCode: "NV", stateName: "Nevada" }
                },
                {
                    type: "selection",
                    itemId: "newHampshire",
                    label: "New Hampshire",
                    data: { stateId: 34, stateCode: "NH", stateName: "New Hampshire" }
                },
                {
                    type: "selection",
                    itemId: "newJersey",
                    label: "New Jersey",
                    data: { stateId: 35, stateCode: "NJ", stateName: "New Jersey" }
                },
                {
                    type: "selection",
                    itemId: "newMexico",
                    label: "New Mexico",
                    data: { stateId: 36, stateCode: "NM", stateName: "New Mexico" }
                },
                {
                    type: "selection",
                    itemId: "newYork",
                    label: "New York",
                    data: { stateId: 37, stateCode: "NY", stateName: "New York" }
                },
                {
                    type: "selection",
                    itemId: "northCarolina",
                    label: "North Carolina",
                    data: { stateId: 38, stateCode: "NC", stateName: "North Carolina" }
                },
                {
                    type: "selection",
                    itemId: "northDakota",
                    label: "North Dakota",
                    data: { stateId: 39, stateCode: "ND", stateName: "North Dakota" }
                },
                {
                    type: "selection",
                    itemId: "ohio",
                    label: "Ohio",
                    data: { stateId: 41, stateCode: "OH", stateName: "Ohio" }
                },
                {
                    type: "selection",
                    itemId: "oklahoma",
                    label: "Oklahoma",
                    data: { stateId: 42, stateCode: "OK", stateName: "Oklahoma" }
                },
                {
                    type: "selection",
                    itemId: "oregon",
                    label: "Oregon",
                    data: { stateId: 43, stateCode: "OR", stateName: "Oregon" }
                },
                {
                    type: "selection",
                    itemId: "pennsylvania",
                    label: "Pennsylvania",
                    data: { stateId: 45, stateCode: "PA", stateName: "Pennsylvania" }
                },
                {
                    type: "selection",
                    itemId: "rhodeIsland",
                    label: "Rhode Island",
                    data: { stateId: 47, stateCode: "RI", stateName: "Rhode Island" }
                },
                {
                    type: "selection",
                    itemId: "southCarolina",
                    label: "South Carolina",
                    data: { stateId: 48, stateCode: "SC", stateName: "South Carolina" }
                },
                {
                    type: "selection",
                    itemId: "southDakota",
                    label: "South Dakota",
                    data: { stateId: 49, stateCode: "SD", stateName: "South Dakota" }
                },
                {
                    type: "selection",
                    itemId: "tennessee",
                    label: "Tennessee",
                    data: { stateId: 50, stateCode: "TN", stateName: "Tennessee" }
                },
                {
                    type: "selection",
                    itemId: "texas",
                    label: "Texas",
                    data: { stateId: 51, stateCode: "TX", stateName: "Texas" }
                },
                {
                    type: "selection",
                    itemId: "utah",
                    label: "Utah",
                    data: { stateId: 52, stateCode: "UT", stateName: "Utah" }
                },
                {
                    type: "selection",
                    itemId: "vermont",
                    label: "Vermont",
                    data: { stateId: 53, stateCode: "VT", stateName: "Vermont" }
                },
                {
                    type: "selection",
                    itemId: "virginia",
                    label: "Virginia",
                    data: { stateId: 54, stateCode: "VA", stateName: "Virginia" }
                },
                {
                    type: "selection",
                    itemId: "washington",
                    label: "Washington",
                    data: { stateId: 56, stateCode: "WA", stateName: "Washington" }
                },
                {
                    type: "selection",
                    itemId: "westVirginia",
                    label: "West Virginia",
                    data: { stateId: 57, stateCode: "WV", stateName: "West Virginia" }
                },
                {
                    type: "selection",
                    itemId: "wisconsin",
                    label: "Wisconsin",
                    data: { stateId: 58, stateCode: "WI", stateName: "Wisconsin" }
                },
                {
                    type: "selection",
                    itemId: "wyoming",
                    label: "Wyoming",
                    data: { stateId: 59, stateCode: "WY", stateName: "Wyoming" }
                }
            ]
        },
        {
            type: "text",
            itemId: "zipCode",
            label: "Zip Code",
            className: "col-md-4",
            mask: "00000",
            required: true,
            rules: {
                zipCode: {
                     "zipCode.valid": { all: [
                        { compare: ["#zipCode.value.length", ">", "4"] }]
                     }
                    }
            }
        },
        // Policy
        {
            type: "text",
            itemId: "policyNumber",
            label: "Policy Number",
            className: "col-md-6"
        },
        {
            type: "date",
            itemId: "policyExpirationDate",
            label: "Policy Expiration Date",
            className: "col-md-6"
        }
    ]
};
